// import { createSelector } from 'reselect';

export const getIsPosting = state => state.getIn(['appointmentFiles', 'isPosting']);
export const getIsPutting = state => state.getIn(['appointmentFiles', 'isPutting']);
export const getIsDeleting = state => state.getIn(['appointmentFiles', 'isDeleting']);
export const getErrMsg = state => state.getIn(['appointmentFiles', 'errMsg']);